// @flow

import React, { type Node } from 'react';

import { TipsBox } from '@tectonics/look-and-feel/shopify/commons/organisms/tips-box';
import { Link } from '@tectonics/look-and-feel/shopify/commons/atoms';

import customerAreaSrc from './help-center-icons/customer-area.svg';

export function HelpCenterInfo(): Node {
  return (
    <div style={{ marginTop: '20px' }}>
      <TipsBox title="¿Ya conoces la Central de Ayuda EBANX?" tipsModel={[
        {
          imgSrc: customerAreaSrc,
          altText: 'list icon',
          tipText: (
            <>
              Si tienes dudas adicionales acerca de tu pago,
              o tu reembolso visítanos en la Central de Ayuda EBANX:
              <br />
              <b>
                <Link href="https://ayuda.ebanx.com/hc/es-co" target="_blank" rel="noopener noreferrer">
                  ayuda.ebanx.com/hc/es-co
                </Link>
              </b>
            </>
          ),
        },
      ]} />
    </div>
  );
}
